
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/CheckGroups/CheckGroups.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./CheckGroups.html');
        
        var script = require('./CheckGroups.ts').default;
        module.exports = require('./CheckGroups.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    